export const HANDLE_MENU_COLLAPSED = 'HANDLE_MENU_COLLAPSED';
export const HANDLE_REFERRAL_FLAGGED = 'HANDLE_REFERRAL_FLAGGED';
export const HANDLE_SELECT_REFERRAL = 'HANDLE_SELECT_REFERRAL';
export const HANDLE_BILLINGS_COUNT = 'HANDLE_BILLINGS_COUNT';
